<template>
    <label :text="label" :style="style" :class="`btn-${c}`">
        <input type="file" :name="inpName" :id="inpId" :multiple="isMultiple" :accept="accept" @change="onChange">
    </label>
</template>

<script setup>

    const props = defineProps({
        label: String,
        inpName: String,
        inpId: String,
        isMultiple: Boolean,
        accept: String,
        style: Object,
        chosenPreview: String,
        files: Object,
        c: String
    });

    const emits = defineEmits([
        "update:chosen-preview",
        "update:files"
    ]);

    function onChange($e) {
        const chosenPreview = URL.createObjectURL($e.target.files[0]);
        emits("update:chosen-preview", chosenPreview);
        emits("update:files", $e.target.files)
    }

</script>

<style lang="less" scoped>
    label {
        width: max-content;

        // --bs-btn-color: #fff;
        // --bs-btn-bg: #0d6efd;
        // --bs-btn-border-color: #0d6efd;
        // --bs-btn-hover-color: #fff;
        // --bs-btn-hover-bg: #0b5ed7;
        // --bs-btn-hover-border-color: #0a58ca;
        // --bs-btn-focus-shadow-rgb: 49,132,253;
        // --bs-btn-active-color: #fff;
        // --bs-btn-active-bg: #0a58ca;
        // --bs-btn-active-border-color: #0a53be;
        // --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        // --bs-btn-disabled-color: #fff;
        // --bs-btn-disabled-bg: #0d6efd;
        // --bs-btn-disabled-border-color: #0d6efd;

        &::after {
            content: attr(text);
            padding: 0.375rem 0.75rem;
            cursor: pointer;
            color: var(--bs-btn-color);
            background-color: var(--bs-btn-bg);
            border-radius: 0.375rem;
            font-size: var(--bs-btn-font-size);
            border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        }

        &:hover::after {
            color: var(--bs-btn-hover-color);
            background-color: var(--bs-btn-hover-bg);
            border-color: var(--bs-btn-hover-border-color);
        }

        &:active::after {
            color: var(--bs-btn-active-color);
            background-color: var(--bs-btn-active-bg);
            border-color: var(--bs-btn-active-border-color);
        }

        input {
            visibility: hidden;
            width: 0;
        }
    }
</style>